import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_13 = { class: "dropdown-menu dropdown-block" }
const _hoisted_14 = {
  key: 0,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_15 = {
  key: 1,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_16 = {
  key: 2,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des produits")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.checkPermission('AddProduit'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "me-2 btn btn-primary",
              to: "/produits/ajouter-produit"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                _createTextVNode(" Ajouter un produit ")
              ])),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-bg svg-color pt-3",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black",
            placeholder: "Rechercher un produit"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Code"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Référence"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Nom"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Famille"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              }, " ACTIONS")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: produit.id
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(produit.codeProduit), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(produit.refProd), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(produit.nomProd), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(produit.famille?.libelleFamille), 1),
                _createElementVNode("td", _hoisted_12, [
                  _cache[8] || (_cache[8] = _createElementVNode("button", {
                    class: "btn dropdown-toggle btn-primary",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, "Actions", -1)),
                  _createElementVNode("ul", _hoisted_13, [
                    (_ctx.checkPermission('ViewProduit'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                          _createVNode(_component_router_link, {
                            to: { name: 'ViewProduit', params: { id: produit.id } },
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode("Détails ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.checkPermission('EditProduit'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                          _createVNode(_component_router_link, {
                            to: { name: 'EditProduit', params: { id: produit.id } },
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode("Modifier ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.checkPermission('DeleteProduit'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(produit.id, _ctx.produits, 'produits', `le produit ${produit.id}`))
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode("Supprimer ")
                          ]), 8, _hoisted_17)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}